const state = {
  isDark: localStorage.getItem('theme') === 'dark' || false
};

const getters = {
  isDarkMode: state => state.isDark,
  currentTheme: state => state.isDark ? 'dark' : 'light'
};

const actions = {
  toggleTheme({ commit, state }) {
    const newTheme = !state.isDark;
    commit('SET_THEME', newTheme);
    localStorage.setItem('theme', newTheme ? 'dark' : 'light');
    
    // Apply theme to document
    if (newTheme) {
      document.documentElement.classList.add('dark-theme');
    } else {
      document.documentElement.classList.remove('dark-theme');
    }
  },
  
  initTheme({ commit, state }) {
    // Apply initial theme to document
    if (state.isDark) {
      document.documentElement.classList.add('dark-theme');
    } else {
      document.documentElement.classList.remove('dark-theme');
    }
  }
};

const mutations = {
  SET_THEME(state, isDark) {
    state.isDark = isDark;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};